module.exports = __webpack_public_path__ + "img/setup-stack-test-min.3592c5b3.jpg";